import { useState, useEffect } from "react";
import { getLatestNewsWidget } from "../api/widgets/latestNews/requests";

function useStoryblokLatestNewsWidget() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getLatestNewsWidget()
      .then(data => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoading(false))
  }, []);

  return [data, isLoading];
}

export { useStoryblokLatestNewsWidget };
